import { Spinner } from "@via/components/loading/loading";
import FoundryConnectLogo from "@via/components/foundry-connect-logo.tsx";
import { ROUTES } from "@via/utils/constants.tsx";
import { useConfigurations } from "@via/api/configuration";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const HUBSPOT_REGION = "na1";

const ContactSalesRequest: React.FC = () => {
  const { data: configurations } = useConfigurations();

  useEffect(() => {
    if (!configurations) return;

    const script = document.createElement("script");
    script.src = "//js.hsforms.net/forms/embed/v2.js";
    script.async = true;

    script.onload = () => {
      if ((window as any).hbspt) {
        (window as any).hbspt.forms.create({
          portalId: configurations?.HUBSPOT_PORTAL_ID,
          formId: configurations?.HUBSPOT_FORM_ID,
          region: HUBSPOT_REGION,
          target: "#hubspotForm",
          onFormReady: () => console.log("Form ready"),
          onFormSubmit: () => console.log("Form submitted"),
          onFormSubmitted: () => console.log("Form submission complete"),
        });
      }
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [configurations]);

  return (
    <>
      <div className="dotted flex flex-col justify-center items-center py-2 px-4 sm:px-6 lg:px-8 min-h-full">
        <div className="w-full max-w-md">
          <FoundryConnectLogo />
          <div className="w-full max-w-md mt-4">
            <div id="hubspotForm">
              <Spinner loading={true} />
            </div>
            <p className="my-10 text-center text-sm text-gray-500">
              Have an account?{" "}
              <Link
                to={ROUTES.LOGIN}
                className="font-semibold ml-1 leading-6 text-indigo-600 hover:text-indigo-500">
                Login here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSalesRequest;
